import { useSelector } from 'react-redux';
import classes from './Progres.module.css'
import { RootState } from '../../Store/store';
const Progres = () => {

    const lessons = useSelector((state:RootState)=>state.user.lessons)
    const maxActiveLessonId = useSelector((state:RootState)=>state.user.maxActiveLessonId)

    return ( 
        <div className={classes.progres}>
            <div className={classes.title}>
                Прогресс обучения
            </div>
            <div className={classes.progressBar}>
                <div className={classes.progressBarLine} style={maxActiveLessonId>=lessons.length?{width:'100%'}:{width:`${maxActiveLessonId/(lessons.length/100)}%`}}/>
            </div>
        </div>
     );
}
 
export default Progres;